import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {ConnectedAppsTabComponent} from './components/connected-apps-tab/connected-apps-tab.component';
import {ConnectedAccountsTabComponent} from './components/connected-accounts-tab/connected-accounts-tab.component';
import {SettingsTabComponent} from './components/settings-tab/settings-tab.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  IsAuthenticatedAuthGuard
} from "./auth-guards/is-authenticated-auth-guard";
import {AccountDetailsComponent} from './pages/account-details/account-details.component';

export const dashboardRoutes: Routes = [
  { path: 'dashboard',
    component: DashboardComponent,
    children:[
      { path: '', redirectTo: 'accounts', pathMatch: 'full' },
      { path: 'apps', pathMatch: 'full', component: ConnectedAppsTabComponent },
      { path: 'accounts/:accountId', component: AccountDetailsComponent },
      { path: 'accounts', pathMatch: 'full', component: ConnectedAccountsTabComponent },
      { path: 'settings', pathMatch: 'full', component: SettingsTabComponent }
    ],
    canActivate: [IsAuthenticatedAuthGuard]
  },
]
@NgModule({
  imports: [
    RouterModule.forChild(dashboardRoutes)
  ],
  exports: [ RouterModule ]
})
export class DashboardRoutingModule { }
